import React from 'react';
import { Outlet } from 'react-router-dom';

import { MainHeader } from './components/main-header/main-header';
import { TopBar } from './components/top-bar/top-bar';
import { PageLoader } from './components/loader/page-loader';
import { Customer } from './models/customer';
import { UserConfig } from './models/user-config';
import { config as appConfig } from './config';

interface Props {
  customerDetails: Customer;
  config: UserConfig | null;
  onLogOut: () => Promise<void>;
}

export const PrivatePage: React.FC<Props> = ({ customerDetails, config, onLogOut }) => {
  return (
    <div>
      {appConfig.showTopBar && <TopBar />}
      <MainHeader customer={customerDetails} onLogOut={onLogOut} />
      <main>
        <React.Suspense fallback={<PageLoader />}>
          <Outlet />
        </React.Suspense>
      </main>
    </div>
  );
};
